<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.type") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <Multiselect id="name"
                           class=""
                           v-model="form.name"
                           :options="configs.map((item) => item.name)"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           :readonly="!!form.id"
                           :disabled="!!form.id"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.trader") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`traderId`)">
              <TraderMultiselect :class="parentProps.class" :isProvider="true" :multiple="false" :small="false" v-model="form.trader" :disabled="!!form.id">
              </TraderMultiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.sysname") }}:</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <input :readonly="!!form.id" :class="parentProps.class" v-model="form.sysname" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.callback_url") }}:</label>
          <div class="col-sm-8">
            <div class="invoice-input-group mb-0">
              <div class="input-group">
                <input type="text" class="form-control  font-monospace" style="font-size: 12px" :value="callbackUrl" readonly>
                <copy-button class="btn btn-copy" :value="callbackUrl"></copy-button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="webhookAuth">
          <div class="col-sm-12">
            <div :class="webhookAuth.isWarning ? 'alert-warning' : 'alert-success'" class="alert mb-0 py-2">
              <strong>{{ helper.trans("labels.webhook_auth") }}: {{ helper.trans(`webhook_auth.${webhookAuth.level}`) }}</strong>
              <div v-if="webhookAuth.note" class="small">{{ webhookAuth.note }}</div>
              <div v-if="webhookAuth.requiredConfigFields.length" class="small">
                {{ helper.trans("labels.webhook_auth_required_fields") }}:
                <code v-for="field in webhookAuth.requiredConfigFields" :key="field" class="me-1">{{ field }}</code>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="currency" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.currency") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" field="currency" form="requisitesForm">
              <Multiselect id="currency"
                           class=""
                           v-model="form.currency"
                           :options="store.getters['currencyMethods/currencies']"
                           :custom-label="(opt) => `${opt}`"
                           :multiple="false"
                           :class="parentProps.class"
                           select-label="Select"
                           placeholder=""
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="minAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.from_sum") }}</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="form.minPayInAmount">
          </div>
        </div>

        <div class="row mt-2">
          <label for="maxAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.to_sum") }}</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="form.maxPayInAmount">
          </div>
        </div>

        <div class="row mt-2">
          <label for="payoutFeeAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payout_fee_amount") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payoutFeeAmount`)">
              <input :class="parentProps.class" type="number" step="0.01" min="0" class="form-control" id="payoutFeeAmount" v-model="form.payoutFeeAmount">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="allowedPaymentOptions" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.payment_options") }}</label>
          <div class="col-sm-8">
            <Multiselect id="allowedPaymentOptions"
                         v-model="form.allowedPaymentOptions"
                         :options="store.getters['currencyMethods/options']()"
                         :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                         :multiple="true"
                         select-label="Select"
                         :placeholder="helper.trans('labels.payment_options')"
            >
            </Multiselect>
          </div>
        </div>

        <div class="row mt-2">
          <label for="defaultPaymentOption" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.default") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`defaultPaymentOption`)">
            <Multiselect id="defaultPaymentOption"
                         :class="parentProps.class"
                         v-model="form.defaultPaymentOption"
                         :options="store.getters['currencyMethods/options']()"
                         :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                         :multiple="false"
                         select-label="Select"
                         :placeholder="helper.trans('labels.payment_options')"
            >
            </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="useProviderAmount" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.use_provider_amount") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.useProviderAmount" class="form-check-input" type="checkbox" id="useProviderAmount">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="config" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.config") }}</label>
          <div class="col-sm-12">
            <FormInputWrapper v-slot="parentProps" :errors="getFieldErrors('config')">
              <textarea ref="configField" :class="parentProps.class" class="form-control" rows="8"></textarea>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="configDocs && Object.keys(configDocs).length">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.config_docs") }}</label>
          <div class="col-sm-12">
            <table class="table table-sm table-bordered mb-0">
              <thead>
                <tr>
                  <th>{{ helper.trans("labels.field") }}</th>
                  <th>{{ helper.trans("labels.type") }}</th>
                  <th>{{ helper.trans("labels.comment") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doc, field) in configDocs" :key="field">
                  <td><code>{{ field }}</code></td>
                  <td>{{ doc.type }}</td>
                  <td>{{ doc.comment }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mt-2">
          <label for="responseAllowlist" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.response_allowlist") }}</label>
          <div class="col-sm-12">
            <FormInputWrapper v-slot="parentProps" :errors="getFieldErrors('responseAllowlist')">
              <textarea ref="responseAllowlistField" :class="parentProps.class" class="form-control" rows="6"></textarea>
            </FormInputWrapper>
          </div>
        </div>

      </div>
    </div>

  </form>
</template>

<script lang="ts">
import {defineComponent, toRefs, reactive, onMounted, computed, ref, watch} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import {api} from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import Multiselect from "vue-multiselect";
import {Direction} from "@/models/enum/Direction";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import {Sortable} from "sortablejs-vue3";
import ProviderFormDTO from "@/models/form/ProviderFormDTO";
import ProviderNameConfigDTO from "@/models/ProviderNameConfigDTO";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import CopyButton from "@/components/CopyButton.vue";
import {normalizeHttpValidationErrors} from "@/service/normalizeHttpValidationErrors";

const notification = useNotification()
export default defineComponent({
  props: {
    role: String
  },
  components: {
    CopyButton,
    TraderMultiselect,
    Sortable,
    PayMethodIcon,
    Multiselect,
    FormInputWrapper,
  },
  setup() {
    const configField = ref<InstanceType<any> | null>(null)
    const responseAllowlistField = ref<InstanceType<any> | null>(null)
    const store = useStore();
    const state = reactive({
      errors: {} as ValidationErrorDTO[]|any,
      form: {} as ProviderFormDTO,
      configs: [] as ProviderNameConfigDTO[]
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const getFieldErrors = (field: string): ValidationErrorDTO[] => {
      const keys = Object.keys(state.errors).filter(
        (k) => k === field || k.startsWith(field + ".")
      );
      keys.sort((a, b) =>
        a === field ? -1 : b === field ? 1 : a.localeCompare(b)
      );
      const out: ValidationErrorDTO[] = [];
      for (const k of keys) {
        out.push(...state.errors[k]);
      }
      return out;
    };

    const trimTrailingZeros = (value: string): string => {
      if (!value.includes('.')) {
        return value;
      }

      return value.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
    }

    const validatePayoutFeeAmount = (value: string|null|undefined): ValidationErrorDTO[] => {
      const trimmed = `${value ?? ''}`.trim();
      if (trimmed === '') {
        return [];
      }

      const num = Number(trimmed);
      if (!/^\d+(\.\d+)?$/.test(trimmed) || isNaN(num) || num < 0) {
        return [{code: "INVALID_VALUE", field: "payoutFeeAmount", message: helper.trans("validation.payout_fee_amount_invalid")}];
      }

      return [];
    }

    const save = () => {
      setErrors([]);
      const form = getForm();

      const payoutFeeAmountErrors = validatePayoutFeeAmount(form.payoutFeeAmount);
      if (payoutFeeAmountErrors.length > 0) {
        setErrors(payoutFeeAmountErrors);
        return Promise.reject(new Error("invalid payoutFeeAmount"));
      }

      // v-model on type="number" casts to a JS number; API needs a string like the other amount fields.
      const trimmedPayoutFeeAmount = `${form.payoutFeeAmount ?? ''}`.trim();
      const payoutFeeAmount = trimmedPayoutFeeAmount === '' ? null : trimTrailingZeros(trimmedPayoutFeeAmount);

      let config;
      let responseAllowlist;
      try {
        config = JSON.parse(configField.value?.value)
        responseAllowlist = JSON.parse(responseAllowlistField.value?.value ?? "null")
      } catch {
        notification.notify({type: "error", title: helper.trans("labels.invalid_json")});
        return Promise.reject(new Error("invalid json"));
      }

      let promise;

      if (form.id) {
        promise = api.call.providers.update(form.id, {
          ...form,
          config,
          responseAllowlist,
          payoutFeeAmount,
        })
      } else {
        promise = api.call.providers.create({
          ...form,
          traderId: state.form.trader?.id,
          config,
          responseAllowlist,
          payoutFeeAmount,
        })
      }


      promise
        .catch((e: any) => {
          if (e.response?.status === 400 && e.response.data) {
            setErrors(normalizeHttpValidationErrors(e.response.data))
          } else {
            console.log(e);
          }

        })

      return promise
    }

    const hasErrors = (path: string) => {
      return state.errors[path]?.length > 0
    }

    const getForm = (): ProviderFormDTO => {
      return state.form
    }

    const callbackUrl = computed(() => {
      return window.location.origin.replace(/:\/\/[^.]*/, '://api') + '/api/aggregator/webhooks/' + (state.form.sysname ?? '')
    })

    const configDocs = computed(() => {
      const providerConfig = state.configs.find((item) => item.name === state.form.name)
      return providerConfig?.configDocs ?? null
    })

    const webhookAuth = computed(() => {
      if (state.form.id && state.form.webhookAuth) {
        return state.form.webhookAuth
      }

      const providerConfig = state.configs.find((item) => item.name === state.form.name)
      return providerConfig?.webhookAuth ?? null
    })

    const setForm = (form: ProviderFormDTO) => {
      state.errors = {}
      state.form = {
        ...form,
        payoutFeeAmount: form.payoutFeeAmount != null ? trimTrailingZeros(form.payoutFeeAmount) : form.payoutFeeAmount,
      }


      if (state.form.id) {
        configField.value!.value = JSON.stringify(state.form.config ?? {}, null, 4)
      }
      responseAllowlistField.value!.value = JSON.stringify(state.form.responseAllowlist ?? null, null, 4)
    }

    watch(() => state.form.name, (value, oldValue) => {
      if (state.form.id) {
        configField.value!.value = JSON.stringify(state.form.config ?? {}, null, 4)
        return;
      }

      if (value === oldValue) {
        return;
      }

      const providerConfig = state.configs.find((item) => item.name === state.form.name)
      const template = providerConfig?.responseAllowlistTemplate
      const allowlist = template && Object.keys(template).length
        ? Object.fromEntries(Object.keys(template).map((code) => [code, []]))
        : null

      const configTemplate = providerConfig?.configTemplate ?? {}
      const configSkeleton = Object.fromEntries(Object.keys(configTemplate).map((field) => [field, '']))
      configField.value!.value = JSON.stringify(configSkeleton, null, 4)
      responseAllowlistField.value!.value = JSON.stringify(allowlist, null, 4)
    })

    onMounted(async () => {
      state.configs = await api.call.providers.configs()
    })

    return {
      ...toRefs(state),
      callbackUrl,
      webhookAuth,
      configDocs,
      getForm,
      setForm,
      store,
      helper,
      numberFormatter,
      setErrors,
      getErrors,
      getFieldErrors,
      hasErrors,
      save,
      Direction,
      configField,
      responseAllowlistField,
    }
  }
})
</script>
